import styled from 'styled-components';

const Container = styled.div<{
  selected: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr 2fr 160px;
  gap: 20px;
  flex-direction: row;
  align-items: center;
  background-color: white;
  border-radius: 4px;
  padding: 20px;
  border: solid 1px
    ${(props) =>
      props.selected ? props.theme.colors['terra-cotta'] : '#e9e9e9'};

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    display: flow;
    padding: 0;
    border: solid 1px
      ${(props) =>
        props.selected ? props.theme.colors['terra-cotta'] : 'transparent'};
  }

  .titleInfosContainer {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    width: 100%;
  }

  .titleDate {
    margin-bottom: 5px;
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    color: #121212;
  }

  .titleCountry {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    font-weight: 400;
    color: ${(props) => props.theme.colors['terra-cotta']};
    text-transform: uppercase;
  }

  .titleCategory {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    font-weight: 400;
    color: ${(props) => props.theme.colors['terra-cotta']};
    text-transform: uppercase;
    margin-left: 10px;
  }

  .titleSource {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    font-weight: 400;
    color: ${(props) => props.theme.colors['dark']};
    text-transform: uppercase;
    margin: 0 10px;
  }

  .titleFavorited {
    cursor: pointer;
    width: 15px;
    height: 15px;
    stroke: ${(props) => props.theme.colors['terra-cotta']};
    color: #fff;
  }

  .titleFavorited--isFav {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .titleFavorited:hover {
    transform: scale(1.2);
  }

  .icon-article-action {
    height: 15px;
  }

  .icon-article-action.star {
    height: 20px;
  }

  .icon-article-action.star-full {
    height: 20px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .articleContentContainer {
    width: 100%;
    height: 140px;
    display: flex;
    align-items: center;
    overflow: hidden;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      height: 90%;
      margin-top: 10px;
    }
  }

  .textLimit {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .contentText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    line-height: 24px;
    height: auto;
    max-height: 100%;
    color: #1f2b37;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .contentText strong {
    font-weight: bold;
  }

  .articleContentContainer > * {
    display: inline;
  }

  .articleListItemSeparator {
    min-height: 100px;
    opacity: 0.5;
    width: 3px;
    background-color: #bcbdbe;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: none;
    }
  }

  .sourceText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    color: rgba(31, 43, 55, 0.5);
    text-decoration: underline;
  }

  .sourceText:hover {
    cursor: pointer;
  }

  a.linkArticle {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 14px;
    color: #1f2b37;

    :hover {
      cursor: pointer;
    }
  }

  .linkArticle.underline {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    text-decoration: underline;
    font-size: 14px;
    color: #1f2b37;
  }

  .tooltip-link {
    visibility: hidden;
    width: 230px;
    height: auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 2px;
    box-shadow: 3px 2px 8px 2px rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(173, 181, 189, 0.2);

    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    line-height: 1.71;
    color: #1f2b37;

    position: absolute;
    z-index: 1;
    bottom: 110px;
    right: -46px;

    ::after {
      content: '';
      width: 10px;
      height: 10px;
      background-color: white;
      border-bottom: solid 1px #e5eef5;
      border-right: solid 1px #e5eef5;
      position: absolute;
      transform: rotate(45deg);
      bottom: -7px;
      left: 50%;
    }
  }

  .actionButtonContainer {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.colors.dark};
    font-size: 12px;
  }

  .actionButtonContainer.empty-link {
    position: relative;
  }

  .actionButtonContainer.empty-link:hover > .tooltip-link {
    visibility: visible;
  }

  .actionsContainer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    width: 100%;
  }

  .actionButtonContainer.disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.5;
  }

  .actionButtonContainer.disabled:hover {
    cursor: default;
  }

  .actionButtonContainer:hover {
    cursor: pointer;
  }

  .titleFavorited {
    stroke: ${(props) => props.theme.colors.dark};
    color: transparent;
  }

  .titleFavorited--isFav {
    stroke: ${(props) => props.theme.colors.dark};
    color: ${(props) => props.theme.colors.dark};
  }

  .rightArticleItem {
    display: flex;
    padding: 0;
    margin-left: auto;
    flex: 0 0 10%;
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-top: 10px;
    }
  }

  .dualActionsContainer {
    display: flex;
    margin-right: 9px;
  }

  .actionsTagContainer {
    margin-top: 10px;
    justify-content: flex-start;
  }

  .actionsTagContainer > div:not(:last-child) {
    margin-right: 5px;
  }

  .addTagContainer {
    cursor: pointer;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: flex;
      align-items: center;
      justify-content: center;

      .tag {
        margin-top: 0 !important;
      }
    }
  }

  .titleContainer {
    display: flex;
    flex-direction: column;
    flex: 0 0 25%;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-top: 25px;
    }
  }

  .rightArticleItemContent {
    background-color: #ebecee;
    padding: 4px 15px;
    border-radius: 25px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }

  .articleContent {
    display: grid;
    gap: 10px;
  }

  .mainArticleCategory {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .mainArticleTitle {
    font-family: ${(props) => props.theme.fonts.silkserif_black};
    font-size: 24px;
    line-height: 24px;
    color: #1f2b37;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .mainArticleInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    opacity: 0.4;
    color: #1f2b37;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
  }

  .mainArticleText {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

export default Container;
